import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-7 5a1 1 0 0 0 -1 1v8a1 1 0 0 0 2 0v-8a1 1 0 0 0 -1 -1","key":"svg-0"}]]

const IconSquareLetterIFilled = createReactComponent('filled', 'square-letter-i-filled', 'SquareLetterIFilled', __iconNode);

export default IconSquareLetterIFilled;